import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { labels } from "../i18n/translations";

export const AdminLogin = () => {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) {
    return (
      <main className="min-h-screen flex items-center justify-center px-6">
        <div className="uppercase tracking-[0.32em] text-[11px] text-black/40">…</div>
      </main>
    );
  }

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      const msg = err?.response?.data?.detail || labels.admin.invalid;
      setError(typeof msg === "string" ? msg : labels.admin.invalid);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main
      data-testid="page-admin-login"
      className="min-h-screen grid grid-cols-1 lg:grid-cols-2"
    >
      <div className="hidden lg:block relative overflow-hidden">
        <img
          src="https://images.pexels.com/photos/1190829/pexels-photo-1190829.jpeg?auto=compress&cs=tinysrgb&w=1400"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/30 via-white/0 to-white/40" />
      </div>

      <div className="flex items-center justify-center px-6 md:px-12 py-16">
        <form onSubmit={onSubmit} className="w-full max-w-sm">
          <div className="font-heading text-2xl md:text-3xl tracking-tight mb-2">
            MB<span className="text-[#C5A059]">.</span>Réserve
          </div>
          <div className="uppercase tracking-[0.32em] text-[10px] text-[#C5A059] mb-8">
            {labels.admin.login_title}
          </div>
          <p className="text-sm text-black/60 font-light mb-10 leading-relaxed">
            {labels.admin.login_subtitle}
          </p>

          <label className="block uppercase tracking-[0.22em] text-[10px] text-black/50 mb-2">
            {labels.admin.email}
          </label>
          <input
            type="email"
            data-testid="admin-email-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full border-0 border-b border-black/30 bg-transparent py-2 mb-6 focus:outline-none focus:border-black text-sm"
          />

          <label className="block uppercase tracking-[0.22em] text-[10px] text-black/50 mb-2">
            {labels.admin.password}
          </label>
          <input
            type="password"
            data-testid="admin-password-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full border-0 border-b border-black/30 bg-transparent py-2 mb-8 focus:outline-none focus:border-black text-sm"
          />

          {error && (
            <div data-testid="admin-login-error" className="text-[11px] uppercase tracking-[0.22em] text-red-600 mb-6">
              {error}
            </div>
          )}

          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={submitting}
            className="w-full bg-black text-white hover:bg-[#C5A059] transition-colors uppercase tracking-[0.22em] text-xs py-4 disabled:opacity-50"
          >
            {submitting ? "…" : labels.admin.login_cta}
          </button>
        </form>
      </div>
    </main>
  );
};

export default AdminLogin;
